import Image from 'next/image';
import { XCircleIcon } from '@heroicons/react/24/outline';
import { Modal } from '@/components/Modal';
import { type Speaker } from '../../events';
import placeholder from './placeholder-headshot.png';
import { GradleElephantWithText } from '@/components/Logos';

export function SpeakerModal({ speaker, isOpen, onClose }: { speaker: Speaker; isOpen: boolean; onClose: () => void }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} header={<SpeakerModalHeader onClose={onClose} />} variant="dark">
      <div className="bg-[#141415]">
        <div className="grid grid-cols-1 place-items-center pt-6 md:grid-cols-[1fr_2fr] md:pt-10">
          <Image
            src={speaker.headshotLink ? `/assets/images/events/event-speakers/${speaker.headshotLink}` : placeholder}
            alt={speaker.name}
            className="mb-6 size-24 rounded-lg md:size-40 md:place-self-start"
            width={96}
            height={96}
          />
          <div className="flex flex-col items-center pb-8 md:items-start md:pb-14 lg:pb-20">
            <GradleElephantWithText className="mb-4" />
            <div className="mb-6 flex flex-col">
              <h2 className="text-h5">{speaker.name}</h2>
              <p className="text-eyebrow text-gray-4">{speaker.title}</p>
            </div>
            <p className="text-body whitespace-pre-line text-gray-4">{speaker.bio}</p>
          </div>
        </div>
      </div>
    </Modal>
  );
}

function SpeakerModalHeader({ onClose }: { onClose: () => void }) {
  return (
    <div className="mb-4 flex items-center justify-between border-b border-[#2E3135] pb-4">
      <span className="text-eyebrow">Speaker</span>
      <button className="group" onClick={onClose}>
        <XCircleIcon className="h-10 transition-transform group-hover:rotate-90" />
      </button>
    </div>
  );
}
